import { render } from "./FlyIcon.vue?vue&type=template&id=286cdbde"
import script from "./FlyIcon.vue?vue&type=script&lang=js"
export * from "./FlyIcon.vue?vue&type=script&lang=js"

import "./FlyIcon.vue?vue&type=style&index=0&id=286cdbde&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__